import React, { useRef, useCallback,useContext } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import L from 'i18n-react';
import types from '../../../../redux/types';
import routes from '../../../../routes';
import {
  firstLatterToUppercase,
  hideEmail,
  thisDemo,
} from '../../../../services/helpers';
import { userSelector } from '../../../../redux/auth/selectors';
import { ThemeContext } from '../../../../ThemeContext';
import { useMediaQuery } from 'react-responsive';


const getStatus = status => {
  switch (status) {
    case 'approved':
      return L.translate('Header.SelectUser.approved');
    case 'rejected':
      return L.translate('Header.SelectUser.reject');
    case 'pending':
      return L.translate('Header.SelectUser.pending');
    case 'unverified':
      return L.translate('Header.SelectUser.unverified');
    default:
      break;
  }
};

const SelectUser = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(userSelector);
  
  const { theme, toggleTheme } = useContext(ThemeContext);

  const handleLogout = () => {
    dispatch({ type: types.LOGOUT_START, payload: { history, type: 'back' } });
  };

  const diactiveteList = classList => {
    setTimeout(() => {
      classList.remove('active');
    }, 300);
  };
  const isMobile = useMediaQuery({ query: '(max-width: 1200px)' });

  return (
    <ul
      className="user-drop"
      onMouseOver={e => e.currentTarget.classList.add('active')}
      onFocus={e => e.currentTarget.classList.add('active')}
      onMouseOut={e => e.currentTarget.classList.remove('active')}
      onBlur={e => diactiveteList(e.currentTarget.classList)}
    >
      <li>
        <button type="button" className="drop-btn" id="open-user-nav">
          <span className="drop-btn__inner">
            <span className={`dtop-name ${theme}`}>{hideEmail(user?.email)}</span>
            <span className="drop-btn__arrow">
              <i className="fa fa-angle-down" />
            </span>
            {!isMobile && (
              <span className="user-extra" style={{ margin: '2px 0' }}>
                <span className="user-lvl">
                  <span className="user-lvl__icon">
                    <img src="/img/vip.png" alt="" />
                  </span>
                  <span className={`user-lvl__text ${theme}`} >VIP {user?.vip_level}</span>
                </span>
                <span
                  className={
                    user?.status?.name !== 'approved'
                      ? 'user-extra__status user-extra__status--unverified'
                      : 'user-extra__status'
                  }
                >
                  {getStatus(user?.status?.name)}
                </span>
              </span>
            )}
          </span>
        </button>
        <div
          className="drop-list"
          onMouseOut={e =>
            e.currentTarget.parentNode.classList.remove('active')
          }
          onBlur={e => e.currentTarget.classList.remove('active')}
        >
          <ul className="drop-list__item">
            <li>
              <Link to={routes.User.Dashboard.path}  className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                {/* <span className="drop-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M39 71.5C39 71.5 65 58.5 65 39V16.25L39 6.5L13 16.25V39C13 58.5 39 71.5 39 71.5Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span> */}
                <span className={`drop-icon  ${theme === 'dark' ? 'dark-icon-dd' : ''}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="55"
                    height="55"
                    viewBox="0 0 55 55"
                    fill="none"
                  >
                    <mask id="path-1-inside-1" fill="white">
                      <path d="M55 27.5C55 42.6878 42.6878 55 27.5 55C12.3122 55 0 42.6878 0 27.5C0 12.3122 12.3122 0 27.5 0C42.6878 0 55 12.3122 55 27.5Z" />
                    </mask>
                    <path
                      className="fill"
                      d="M51 27.5C51 40.4787 40.4787 51 27.5 51V59C44.897 59 59 44.897 59 27.5H51ZM27.5 51C14.5213 51 4 40.4787 4 27.5H-4C-4 44.897 10.103 59 27.5 59V51ZM4 27.5C4 14.5213 14.5213 4 27.5 4V-4C10.103 -4 -4 10.103 -4 27.5H4ZM27.5 4C40.4787 4 51 14.5213 51 27.5H59C59 10.103 44.897 -4 27.5 -4V4Z"
                      fill="black"
                      mask="url(#path-1-inside-1)"
                    />
                    <path
                      d="M13.4998 37C11.4998 33.3333 8.79994 23.9 13.9999 17.5C20.4999 9.49996 29.5 10 34.4999 12"
                      stroke={theme === 'dark' ? '#000000' : '#FFFFFF'} 
                      strokeWidth="4"
                    />
                    <path
                      d="M43 20.5C44.5 23.1667 46.4 30.2 42 37"
                      stroke="black"
                      strokeWidth="4"
                    />
                    <path
                      d="M41 14.5L30.5 24.5"
                      stroke="black"
                      strokeWidth="4"
                    />
                    <circle
                      cx="27.5"
                      cy="27.5"
                      r="4.5"
                      stroke="black"
                      strokeWidth="4"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.dashboard')}
              </Link>
            </li>
            <li>
              <Link to={routes.User.Security.path} className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                <span className={`drop-icon  ${theme === 'dark' ? 'dark-icon-dd' : ''}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M39 71.5C39 71.5 65 58.5 65 39V16.25L39 6.5L13 16.25V39C13 58.5 39 71.5 39 71.5Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.security')}
              </Link>
            </li>

            <li>
              <Link
                to={routes.User.IdentityVerificationKYC.path}
                className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}
              >
                <span className={`drop-icon  ${theme === 'dark' ? 'dark-icon-dd' : ''}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M52 68.2499V61.7499C52 58.3021 50.6304 54.9955 48.1924 52.5576C45.7544 50.1196 42.4478 48.7499 39 48.7499H16.25C12.8022 48.7499 9.49558 50.1196 7.05761 52.5576C4.61964 54.9955 3.25 58.3021 3.25 61.7499V68.2499"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M27.625 35.75C34.8047 35.75 40.625 29.9297 40.625 22.75C40.625 15.5703 34.8047 9.75 27.625 9.75C20.4453 9.75 14.625 15.5703 14.625 22.75C14.625 29.9297 20.4453 35.75 27.625 35.75Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M55.25 35.75L61.75 42.25L74.75 29.25"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.identification')} (KYC)
              </Link>
            </li>
            <li>
              <Link to={routes.User.PersonalInfo.path} className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                <span className={`drop-icon  ${theme === 'dark' ? 'dark-icon-dd' : ''}`}>
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.625 8.25H19"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.625 11.75H19"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.07324 11.75C9.52299 11.75 10.6982 10.5747 10.6982 9.125C10.6982 7.67525 9.52299 6.5 8.07324 6.5C6.62349 6.5 5.44824 7.67525 5.44824 9.125C5.44824 10.5747 6.62349 11.75 8.07324 11.75Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.68262 14.3749C4.87682 13.6236 5.31512 12.9581 5.92866 12.483C6.5422 12.0079 7.29621 11.75 8.07222 11.75C8.84822 11.75 9.60225 12.0078 10.2158 12.4828C10.8294 12.9579 11.2677 13.6234 11.462 14.3747"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21.625 1.25H2.375C1.89175 1.25 1.5 1.64175 1.5 2.125V17.875C1.5 18.3582 1.89175 18.75 2.375 18.75H21.625C22.1082 18.75 22.5 18.3582 22.5 17.875V2.125C22.5 1.64175 22.1082 1.25 21.625 1.25Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {L.translate('UsersPage.PersonalInfo.personal_info')}
              </Link>
            </li>
            <li>
              <Link to={routes.User.ApiManagement.path} className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                <span className={`drop-icon  ${theme === 'dark' ? 'dark-icon-dd' : ''}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M58.5 13H19.5C15.9101 13 13 15.9101 13 19.5V58.5C13 62.0899 15.9101 65 19.5 65H58.5C62.0899 65 65 62.0899 65 58.5V19.5C65 15.9101 62.0899 13 58.5 13Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M48.75 29.25H29.25V48.75H48.75V29.25Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M29.25 3.25V13"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M48.75 3.25V13"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M29.25 65V74.75"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M48.75 65V74.75"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M65 29.25H74.75"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M65 45.5H74.75"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.25 29.25H13"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.25 45.5H13"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.API_management')}
              </Link>
            </li>
            {/* <li>
              <Link to={routes.User.RewardCenter.path} className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                <span className="drop-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M71.5 39H6.5"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.7125 16.6076L6.5 39.0001V58.5001C6.5 60.224 7.18482 61.8773 8.40381 63.0963C9.62279 64.3152 11.2761 65.0001 13 65.0001H65C66.7239 65.0001 68.3772 64.3152 69.5962 63.0963C70.8152 61.8773 71.5 60.224 71.5 58.5001V39.0001L60.2875 16.6076C59.7494 15.5246 58.9198 14.6133 57.8921 13.976C56.8644 13.3387 55.6793 13.0007 54.47 13.0001H23.53C22.3207 13.0007 21.1356 13.3387 20.1079 13.976C19.0802 14.6133 18.2506 15.5246 17.7125 16.6076V16.6076Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M19.5 52.0001H19.5329"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M32.5 52.0001H32.5329"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.reward_center')}
              </Link>
            </li> */}
            {/* <li>
              <Link to={routes.User.Referrals.path} className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                <span className="drop-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M52 68.25V61.75C52 58.3022 50.6304 54.9956 48.1924 52.5576C45.7544 50.1196 42.4478 48.75 39 48.75H16.25C12.8022 48.75 9.49558 50.1196 7.05761 52.5576C4.61964 54.9956 3.25 58.3022 3.25 61.75V68.25"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M27.625 35.75C34.8047 35.75 40.625 29.9297 40.625 22.75C40.625 15.5703 34.8047 9.75 27.625 9.75C20.4453 9.75 14.625 15.5703 14.625 22.75C14.625 29.9297 20.4453 35.75 27.625 35.75Z"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M65 26V45.5"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M74.75 35.75H55.25"
                      stroke="#00D496"
                      strokeWidth="6.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.referral_system')}{' '}
              </Link>
            </li> */}

            {!thisDemo() && (
              <li>
                <NavLink to={routes.Referral.path} className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}>
                  <span className={`drop-icon  ${theme === 'dark' ? 'dark-icon-dd' : ''}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="78"
                      height="78"
                      viewBox="0 0 78 78"
                      fill="none"
                    >
                      <path
                        d="M52 68.25V61.75C52 58.3022 50.6304 54.9956 48.1924 52.5576C45.7544 50.1196 42.4478 48.75 39 48.75H16.25C12.8022 48.75 9.49558 50.1196 7.05761 52.5576C4.61964 54.9956 3.25 58.3022 3.25 61.75V68.25"
                        stroke="#00D496"
                        strokeWidth="6.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M27.625 35.75C34.8047 35.75 40.625 29.9297 40.625 22.75C40.625 15.5703 34.8047 9.75 27.625 9.75C20.4453 9.75 14.625 15.5703 14.625 22.75C14.625 29.9297 20.4453 35.75 27.625 35.75Z"
                        stroke="#00D496"
                        strokeWidth="6.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M65 26V45.5"
                        stroke="#00D496"
                        strokeWidth="6.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M74.75 35.75H55.25"
                        stroke="#00D496"
                        strokeWidth="6.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>

                  <span className="account-bav__text">
                    {L.translate('ReferralsPage.referral_system')}
                  </span>
                </NavLink>
              </li>
            )}
            <li>
              <button
                type="button"
                className={`drop-btn  ${theme === 'dark' ? 'dark-color exchange-drop' : ''}`}
                // onClick={handleLogout} // two click logout
                onPointerDown={handleLogout}
              >
                <span className={`drop-icon ${theme === 'dark' ? 'dark-icon-dd' : 'drop-icon--logout'}`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="78"
                    height="78"
                    viewBox="0 0 78 78"
                    fill="none"
                  >
                    <path
                      d="M20.6871 17.2498C21.6485 17.2498 22.5705 16.8679 23.2503 16.188C23.9302 15.5082 24.3121 14.5862 24.3121 13.6248C24.3121 12.6634 23.9302 11.7413 23.2503 11.0615C22.5705 10.3817 21.6485 9.99976 20.6871 9.99976H13.437C12.4756 9.99976 11.5536 10.3817 10.8738 11.0615C10.1939 11.7413 9.81201 12.6634 9.81201 13.6248V64.375C9.81201 65.3364 10.1939 66.2584 10.8738 66.9383C11.5536 67.6181 12.4756 68 13.437 68H20.6871C21.6485 68 22.5705 67.6181 23.2503 66.9383C23.9302 66.2584 24.3121 65.3364 24.3121 64.375C24.3121 63.4136 23.9302 62.4915 23.2503 61.8117C22.5705 61.1319 21.6485 60.75 20.6871 60.75H17.062V17.2498H20.6871ZM70.7848 36.8974L60.5622 22.3973C60.0078 21.6158 59.1666 21.0856 58.2224 20.9225C57.2782 20.7595 56.3078 20.9769 55.5235 21.5273C55.1314 21.802 54.7976 22.1517 54.5415 22.5561C54.2853 22.9605 54.1117 23.4117 54.0308 23.8835C53.9499 24.3554 53.9633 24.8385 54.0702 25.3052C54.177 25.7718 54.3753 26.2127 54.6535 26.6023L60.8885 35.3749H31.5621C30.6007 35.3749 29.6787 35.7568 28.9988 36.4366C28.319 37.1164 27.9371 38.0385 27.9371 38.9999C27.9371 39.9613 28.319 40.8833 28.9988 41.5632C29.6787 42.243 30.6007 42.6249 31.5621 42.6249H60.5622L54.0372 51.3249C53.7516 51.7058 53.5438 52.1391 53.4256 52.6003C53.3075 53.0614 53.2813 53.5413 53.3486 54.0126C53.416 54.4839 53.5754 54.9372 53.818 55.3469C54.0605 55.7565 54.3814 56.1143 54.7622 56.3999C55.3897 56.8706 56.1529 57.125 56.9372 57.125C57.5 57.125 58.055 56.9939 58.5584 56.7422C59.0617 56.4906 59.4996 56.1252 59.8372 55.6749L70.7123 41.1749C71.1765 40.5618 71.4338 39.8169 71.4468 39.048C71.4598 38.279 71.228 37.5259 70.7848 36.8974V36.8974Z"
                      fill="#00D496"
                    />
                  </svg>
                </span>
                {L.translate('Header.SelectUser.log_out')}
              </button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  );
};

export default SelectUser;